export type PlatformExternalId = "whats";
export type ContactExtenalId = "whats";

export enum PlatformsName {
  WHATSAPP = "WHATSAPP",
  WHATSAPP_BSP = "WHATSAPP_BSP",
  VTEX = "VTEX",
  TRAY = "TRAY COMMERCE",
  ASAAS = "ASAAS",
}

export enum PlatformCategory {
  "communication" = 1,
  "e-commerce" = 2,
  "erp" = 3,
  "payment" = 4,
  logistics = 5,
  attendance = 6,
}
